import type { TFunction } from 'i18next';
import type { Category, Subcategory } from '../../domain/model';

/**
 * What a category is called on screen: the user's own name when they gave
 * one (renaming a default stores a name), otherwise the default's name in
 * the app language.
 */
export function categoryLabel(t: TFunction, c: Pick<Category | Subcategory, 'name' | 'systemKey'> | undefined | null): string {
  if (!c) return t('categories.other');
  if (c.name) return c.name;
  if (c.systemKey) return t(`categories.${c.systemKey}`);
  return t('categories.other');
}
